// extracted by mini-css-extract-plugin
export default {"error":"Location_error__D0rZs","back":"Location_back__2jZ4+","logoBack":"Location_logoBack__ogRfN","inputHeight":"Location_inputHeight__OIhJ2","question":"Location_question__M5oVQ"};